import TravellerChangeWarningModalHandler from './travellerChangeWarningModalHandler';
export const changeTravellerAction = {
  change: TravellerChangeWarningModalHandler.trigger
};